import { useParams } from "react-router-dom";

export function useOnboardingLivePdfParamsOrThrow() {
  const { userGroupId } = useParams();
  if (!userGroupId) throw new Error("Missing route param: userGroupId");
  return { userGroupId };
}
